import { render, staticRenderFns } from "./ClassFeatureFields.vue?vue&type=template&id=e874e016"
import script from "./ClassFeatureFields.vue?vue&type=script&lang=js"
export * from "./ClassFeatureFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports